import commonMapping from "@/mapping/common";

const security_type_list = [
  {
    id: "security_disable",
    value: "Disable",
    label: "sec_off",
    config: "None",
  },
  {
    id: "security_wpa2",
    value: "WPA2-PSK",
    label: "sec_wpa2",
    config: "WPA2-Personal",
  },
  {
    id: "security_auto",
    value: "AUTO-PSK",
    label: "sec_wpas",
    config: "WPA-Personal+WPA2-Personal",
  },
  {
    id: "security_wpa_enter",
    value: "WPA2-Enterprise",
    label: "sec_wpa2_enterprise",
    config: "WPA2-Enterprise",
  },
  {
    id: "security_wpa3",
    value: "WPA3-PSK",
    label: "sec_wpa3_personal",
    config: "WPA3-Personal",
  },
  {
    id: "security_wpa3_enter",
    value: "WPA3-Enterprise",
    label: "sec_wpa3_enterprise",
    config: "WPA3-Enterprise",
  },
  {
    id: "security_wpa2ewpa3",
    value: "WPA2WPA3",
    label: "sec_wpa2ewpa3",
    config: "WPA2-Personal+WPA3-Personal",
  },
];

const security_type_list_an = [
  {
    id: "security_disable_an",
    value: "Disable",
    label: "sec_off",
    config: "None",
  },
  {
    id: "security_wpa2_an",
    value: "WPA2-PSK",
    label: "sec_wpa2",
    config: "WPA2-Personal",
  },
  {
    id: "security_auto_an",
    value: "AUTO-PSK",
    label: "sec_wpas",
    config: "WPA-Personal+WPA2-Personal",
  },
  {
    id: "security_wpa_enter_an",
    value: "WPA2-Enterprise",
    label: "sec_wpa2_enterprise",
    config: "WPA2-Enterprise",
  },
  {
    id: "security_wpa3_an",
    value: "WPA3-PSK",
    label: "sec_wpa3_personal",
    config: "WPA3-Personal",
  },
  {
    id: "security_wpa3_enter_an",
    value: "WPA3-Enterprise",
    label: "sec_wpa3_enterprise",
    config: "WPA3-Enterprise",
  },
  {
    id: "security_wpa2ewpa3_an",
    value: "WPA2WPA3",
    label: "sec_wpa2ewpa3",
    config: "WPA2-Personal+WPA3-Personal",
  },
];
const security_type_guest_list = [
  {
    id: "security_disable",
    value: "Disable",
    label: "sec_off",
    config: "None",
  },
  {
    id: "security_wpa2",
    value: "WPA2-PSK",
    label: "sec_wpa2",
    config: "WPA2-Personal",
  },
  {
    id: "security_auto",
    value: "AUTO-PSK",
    label: "sec_wpas",
    config: "WPA-Personal+WPA2-Personal",
  },
  {
    id: "security_wpa_enter",
    value: "WPA2-Enterprise",
    label: "sec_wpa2_enterprise",
    config: "WPA2-Enterprise",
  },
  {
    id: "security_wpa3",
    value: "WPA3-PSK",
    label: "sec_wpa3_personal",
    config: "WPA3-Personal",
  },
  {
    id: "security_wpa3_enter",
    value: "WPA3-Enterprise",
    label: "sec_wpa3_enterprise",
    config: "WPA3-Enterprise",
  },
  {
    id: "security_wpa2ewpa3",
    value: "WPA2WPA3",
    label: "sec_wpa2ewpa3",
    config: "WPA2-Personal+WPA3-Personal",
  },
  {
    id: "security_owe",
    value: "OWE",
    label: "sec_owe",
    config: "None+OWE",
  },
];
const security_type_guest_an_list = [
  {
    id: "security_disable_an",
    value: "Disable",
    label: "sec_off",
    config: "None",
  },
  {
    id: "security_wpa2_an",
    value: "WPA2-PSK",
    label: "sec_wpa2",
    config: "WPA2-Personal",
  },
  {
    id: "security_auto_an",
    value: "AUTO-PSK",
    label: "sec_wpas",
    config: "WPA-Personal+WPA2-Personal",
  },
  {
    id: "security_wpa_enter_an",
    value: "WPA2-Enterprise",
    label: "sec_wpa2_enterprise",
    config: "WPA2-Enterprise",
  },
  {
    id: "security_wpa3_an",
    value: "WPA3-PSK",
    label: "sec_wpa3_personal",
    config: "WPA3-Personal",
  },
  {
    id: "security_wpa3_enter_an",
    value: "WPA3-Enterprise",
    label: "sec_wpa3_enterprise",
    config: "WPA3-Enterprise",
  },
  {
    id: "security_wpa2ewpa3_an",
    value: "WPA2WPA3",
    label: "sec_wpa2ewpa3",
    config: "WPA2-Personal+WPA3-Personal",
  },
  {
    id: "security_owe_an",
    value: "OWE",
    label: "sec_owe",
    config: "None+OWE",
  },
];

const auth_mode = [
  {
    id: "local",
    value: "local",
    label: "gp_local",
    config: "local",
  },
  // {
  //   id: "lfacebookcal",
  //   value: "facebook",
  //   label: "gp_fb_wifi",
  //   config: "fbwifi",
  // },
];

const enable = [
  { value: false, config: "0" },
  { value: true, config: "1" },
];

const schedule_enable = [
  { value: false, config: "0" },
  { value: true, config: "1" },
];

export const multiSsid = {
  region: commonMapping.regionList,
  enable: enable,
  broadcast_enable: commonMapping.intToBoolean,
  separate_ssid_enable: commonMapping.intToBoolean,
  vlan_enable: commonMapping.intToBoolean,
  traffic_limit_enable: commonMapping.intToBoolean,
  security_type: security_type_list,
  security_type_an: security_type_list_an,
  security_type_guest: security_type_guest_list,
  security_type_guest_an: security_type_guest_an_list,
  auth_mode: auth_mode,
  schedule_enable: schedule_enable,
};

export default multiSsid;
